import { createFileRoute } from '@tanstack/react-router'
import { Nota } from '@/features/nota/Nota'

/** Nota de evolução da sessão. Aba das páginas da sessão; a chave fica no layout. */
export const Route = createFileRoute('/_app/app/s/$id_/_sessao/nota')({
  component: function NotaDaSessao() {
    const { id } = Route.useParams()
    return <Nota key={id} sessionId={id} />
  },
})
